export default "__VITE_ASSET__8MEk_W1c__"